import { BaseApiClass } from '../base-api-class';

type CustomizationAttribute = string | number | boolean;

type ProductRequestDto = {
  templateId: string;
  weight: number | string;
  customizationAttributes?: Record<string, CustomizationAttribute>;
};

type ProductionOrderMetadata = Record<string, CustomizationAttribute> & {
  origin: string;
};

export type OrderRequestDto = {
  content: ProductRequestDto[];
  metadata: ProductionOrderMetadata;
  locationId: string;
};

export class ProductFormulationApi extends BaseApiClass {
  /** Commits a new order to the register. */
  public readonly submitProductionOrder = this.createEndpoint<OrderRequestDto, { trackingNumber: string }>({
    method: 'post',
    endpoint: ['orders'],
    requestConfig: ({ locationId, ...order }) => ({
      data: order,
      query: {
        lid: locationId,
      },
    }),
  });
}
